import PropTypes from 'prop-types';
export const ctaPropTypes = {
  /**
   * Heading value
   */
  heading: PropTypes.string,
  /**
   * Description value
   */
  description: PropTypes.string,
  /**
   * Button as an object of label and href
   */
  button: PropTypes.shape({
    label: PropTypes.string,
    href: PropTypes.string
  })
};